import { useEffect, useState } from "react";
import { AcademyService } from "../../../Component/Api/Academy/AcademyService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { SmallLoading } from "../../../Component/Common/Components/Loading/IntermediateLoading";
import { PublicEventSectionItem } from "../../../Component/Model/Dto/Academy";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { PublicEventSectionTableMapper } from "./PublicEventsSectionColumns";

interface IProps {
    sectionId: number;
}

export const PublicEventSectionDataTable = (props: IProps) => {

    const [publicEventSectionItemsData, setPublicEventSectionItemsData] = useState<PublicEventSectionItem.DtoIn[]>([]);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const sectionItemsSearchRequest: PublicEventSectionItem.SearchRequest = {
        Draw: 2,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        SearchValue: searchValue,
        SectionId: props.sectionId
    }

    const fetchSectionItems = async () => {
        setIsLoading(true);
        try {
            let response = await AcademyService.SearchPublicEventSectionItems(sectionItemsSearchRequest);
            if (response.data){
                setPublicEventSectionItemsData(response.data.results);
                setFilteredItemsCount(response.data.filteredItemsCount);
                setTotalItemsCount(response.data.totalItemsCount);    
            }
        }
        catch (error) {
            console.error("Unable to retrieve Public Events search results");
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchSectionItems();
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const sectionTableData = PublicEventSectionTableMapper(publicEventSectionItemsData);

    return (
        <>
            <DataTable
                table={sectionTableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
            ></DataTable>
        </>
    )
}
